import { Outlet, useLocation } from 'react-router-dom';

import { PlatformNavbar } from './PlatformNavbar';
import { BackToHomeBar } from './BackToHomeBar';
import { Footer } from './Footer';
import { LoginModal } from '@/features/auth/components/LoginModal';
import { WelcomeBanner } from '@/features/auth/components/WelcomeBanner';
import { SupportGateModal } from '@/features/auth/components/SupportGateModal';
import { LeadCaptureModal } from '@/features/lead-capture/components/LeadCaptureModal';
import { RouteSeo } from '@/features/seo/components/RouteSeo';

export function PlatformLayout() {
  const location = useLocation();
  const isUserArea = location.pathname.startsWith('/my/');

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-b from-brand-teal-50 to-white">
      <RouteSeo />
      <PlatformNavbar />
      <div className="flex-1">
        {isUserArea && <BackToHomeBar />}
        <Outlet />
      </div>
      <Footer />
      <LoginModal />
      <WelcomeBanner />
      <SupportGateModal />
      <LeadCaptureModal />
    </div>
  );
}
